import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  id: '',
  employee_nik: '',
  employee_name: '',
  fuel_date: '',
  fuel_date_only: '',
  fuel_time_only: '',
  fuel_address: '',
  fuel_longlat: '',
  foto_km: '',
  foto_km_url: '',
  foto_kwitansi: '',
  foto_kwitansi_url: '',
  fuel_liter: '',
  fuel_createdby: '',
  fuel_createddate: '',
  fuel_modifyby: '',
  fuel_modifydate: '',
  rowid: '',
  created_at: '',
  updated_at: '',
  fuel_km: '',
  vehicle_id: '',
  fuel_km_akhir: '',
  fuel_rute: '',
  fuel_liter_beli: '',
  old_id: '',
  model_id: '',
  vehicle_nopol: '',
  vehicle_label: '',
  vehicle_type: '',
  log: [],
  tabs: {
    log: 'Log',
    record: 'Record',
  },
};

const readRoot = (payload) => payload?.data || payload || {};
const readHeader = (payload) => {
  const root = readRoot(payload);
  return root?.Header || root?.header || root?.H || root;
};
const readLog = (payload) => {
  const root = readRoot(payload);
  if (Array.isArray(root?.D?.Log)) return root.D.Log;
  if (Array.isArray(root?.Detail?.Log)) return root.Detail.Log;
  if (Array.isArray(root?.Log)) return root.Log;
  if (Array.isArray(root?.log)) return root.log;
  return [];
};
const readTabs = (payload) => {
  const root = readRoot(payload);
  return root?.Tabs || root?.tabs || {};
};

const splitFuelDate = (value) => {
  const text = String(value || '').trim();
  if (!text) {
    return {
      fuel_date_only: '',
      fuel_time_only: '',
    };
  }

  const normalized = text.replace('T', ' ');
  return {
    fuel_date_only: normalized.slice(0, 10),
    fuel_time_only: normalized.slice(11, 16),
  };
};

const normalizePayload = (payload) => {
  const header = readHeader(payload);
  const log = readLog(payload);
  const tabs = readTabs(payload);
  const { fuel_date_only, fuel_time_only } = splitFuelDate(header?.fuel_date);

  return {
    ...header,
    fuel_date_only,
    fuel_time_only,
    vehicle_label: header?.vehicle_type || header?.vehicle_id || '',
    log,
    tabs: {
      ...initialFormData.tabs,
      ...tabs,
      record: tabs?.record || initialFormData.tabs.record,
    },
  };
};

const initialState = {
  selectedRow: null,
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const ops07fuelSlice = createSlice({
  name: 'ops07fuel',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    clearFormData: (state) => { state.formData = initialFormData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      const payload = normalizePayload(action.payload || {});
      state.formData = {
        ...initialFormData,
        ...payload,
      };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      const merged = { ...state.formData, ...action.payload };
      if (Object.prototype.hasOwnProperty.call(action.payload, 'fuel_date_only') || Object.prototype.hasOwnProperty.call(action.payload, 'fuel_time_only')) {
        merged.fuel_date = `${merged.fuel_date_only || ''}${merged.fuel_time_only ? ` ${merged.fuel_time_only}:00` : ''}`.trim();
      }
      state.loading = false;
      state.formData = merged;
    },
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialFormData;
    },
  },
});

export const {
  setSelectedRow,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  setActiveTab,
  clearModuleState,
} = ops07fuelSlice.actions;

export default ops07fuelSlice.reducer;
